var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgJobPostings(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 183,
    height: 183,
    viewBox: "0 0 183 183",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M102.938 62.9062L68.625 76.25L34.3125 62.9062V17.1562L68.625 3.8125L102.938 17.1562V62.9062Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M122.541 110.562L120.414 103.121L118.188 95.3125L68.625 83.875L19.0625 95.3125L3.8125 148.688H118.188V179.188H179.188V110.562H122.541Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M42.8906 13.8241L68.625 26.6875H102.938V17.1562L68.625 3.8125L42.8906 13.8241Z",
    fill: "#BBD8FF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M179.188 163.938H118.188V179.188H179.188V163.938Z",
    fill: "#BBD8FF"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M102.938 62.9062L68.625 76.25L34.3125 62.9062V17.1562L68.625 3.8125L102.938 17.1562V62.9062Z",
    stroke: "#092F63",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M57.1875 45.75V41.9375",
    stroke: "#092F63",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M80.0625 45.75V41.9375",
    stroke: "#092F63",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M118.188 95.3125L68.625 83.875L19.0625 95.3125L3.8125 148.688H102.938",
    stroke: "#092F63",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M42.8906 13.8241L68.625 26.6875H102.938V17.1562L68.625 3.8125L42.8906 13.8241Z",
    stroke: "#092F63",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M87.3292 88.1907L68.625 118.188L49.9209 88.1907L68.625 83.875L87.3292 88.1907Z",
    stroke: "#092F63",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M133.438 141.062H163.938",
    stroke: "#092F63",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M133.438 125.812H163.938",
    stroke: "#092F63",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M133.438 156.312H148.688",
    stroke: "#092F63",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M179.188 110.562H118.188V179.188H179.188V110.562Z",
    stroke: "#092F63",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgJobPostings);
export default __webpack_public_path__ + "static/media/jobPostings.a917a873c1ba988af93cc3a174c28631.svg";
export { ForwardRef as ReactComponent };